import React from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import {Button, Icon} from "bloomer";
import styled from "react-emotion";
import Spacer from "../../../elements/Spacer";

const ButtonsContainer = styled("div")`
    display: flex;
    justify-content: center;
    margin: auto;
`;

interface IProfilePictureCropProps {
    image: string;
    onClose: any;
    onSave: any;
}

interface IProfilePictureCropState {
    image: any;
    cropper: any;
    enabled: any;
}


class ProfilePictureCrop extends React.Component<IProfilePictureCropProps, IProfilePictureCropState> {
    public cropperRef: any = null;

    public constructor(props: IProfilePictureCropProps) {
        super(props);

        this.state = {
            image: props.image,
            cropper: "undefined",
            enabled: false
        };
    }

    public toggleCrop = () => {
        const cropper = this.state.cropper;
        if (typeof cropper !== "undefined") {
            const enabled = this.state.enabled;
            if (enabled) {
                cropper.clear();
            } else {
                cropper.crop();
            }
            this.setState({
                enabled: !enabled
            });
        }
    };

    public rotate = (degree: number) => {
        const cropper = this.state.cropper;
        if (typeof cropper !== "undefined") {
            cropper.rotate(degree);
        }
    };

    public rotateToLeft = () => {
        this.rotate(-90);
    };

    public rotateToRight = () => {
        this.rotate(90);
    };

    public render() {
        return <div className="modal is-active">
            <div className="modal-background" style={{
                opacity: 0.5
            }} onMouseDown={() => {
                this.props.onClose();
            }}>&nbsp;</div>
            <div className="modal-content">
                <div
                    className="has-background-light"
                    style={{
                        maxWidth: '580px',
                        margin: 'auto',
                        padding: '30px 50px',
                        textAlign: 'center',
                        position: 'relative'
                    }}
                >
                    <Button
                        title="Close"
                        className="has-background-light"
                        style={{
                            position: 'absolute',
                            top: '10px',
                            right: '10px',
                            border: 0
                        }}
                        onClick={() => {
                            this.props.onClose();
                        }}
                    >
                        <Icon className="fas fa-times" style={{
                            color: 'grey',
                            fontSize: '24px',
                            fontWeight: 'normal'
                        }}/>
                    </Button>
                    <div style={{
                        fontSize: '24px'
                    }}>Edit Profile Picture
                    </div>
                    <div style={{
                        padding: '30px',
                        textAlign: 'center'
                    }}>
                        <Cropper
                            style={{
                                display: "block",
                                maxWidth: "100%"
                            }}
                            autoCrop={false}
                            initialAspectRatio={1}
                            src={this.state.image}
                            viewMode={2}
                            minCropBoxHeight={10}
                            minCropBoxWidth={10}
                            background={false}
                            responsive={true}
                            checkOrientation={false}
                            onInitialized={(instance) => {
                                this.setState({
                                    cropper: instance
                                });
                            }}
                            guides={false}
                        />
                        <Spacer/>
                        <ButtonsContainer>
                            <Button
                                title="Rotate Left"
                                style={{
                                    margin: '0 5px',
                                    width: '100px'
                                }}
                                onClick={() => {
                                    this.rotateToLeft();
                                }}
                            >
                                <Icon className="fas fa-undo" style={{
                                    marginRight: '5px'
                                }}/>Left
                            </Button>
                            <Button
                                title="Rotate Right"
                                style={{
                                    margin: '0 5px',
                                    width: '100px'
                                }}
                                onClick={() => {
                                    this.rotateToRight();
                                }}
                            >
                                <Icon className="fas fa-redo" style={{
                                    marginRight: '5px'
                                }}/>Right
                            </Button>

                            <Button
                                title={(this.state.enabled ? "Disable" : "Enable") + " Crop"}
                                style={{
                                    margin: '0 5px',
                                    width: '100px'
                                }}
                                className={this.state.enabled ? "has-background-black has-text-white" : undefined}
                                onClick={() => {
                                    this.toggleCrop();
                                }}
                            >
                                <Icon className="fas fa-crop" style={{
                                    marginRight: '5px'
                                }}/>Crop
                            </Button>
                        </ButtonsContainer>
                        <Spacer/>
                        <ButtonsContainer>
                            <Button
                                onClick={() => {
                                    const cropper = this.state.cropper;
                                    if (typeof cropper !== "undefined") {
                                        cropper.getCroppedCanvas().toBlob((blob: Blob) => {
                                            this.props.onSave(blob);
                                        });
                                    }
                                }}
                                className="has-text-white has-background-grey" style={{
                                marginRight: '20px',
                                width: '100px'
                            }}>Save</Button>
                            <Button
                                className="has-background-light"
                                style={{
                                    width: '100px'
                                }}
                                onClick={() => {
                                    this.props.onClose();
                                }}
                            >Cancel</Button>
                        </ButtonsContainer>
                    </div>
                </div>
            </div>
        </div>;
    }
}

;

export default ProfilePictureCrop;


// WEBPACK FOOTER //
// ./src/routes/Settings/ProfilePictureCrop/index.tsx